import React, { ReactElement, useState } from 'react'
import { Button, List, Popconfirm } from 'antd'
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import HeaderPage from '@components/atoms/HeaderPage'
import { useFetch, useRouter } from '@customHooks'
import { ContainerTabela } from '@pages/style'
import api from '@services/api'

export default function UsuariosEmpresa(): ReactElement {
  const { navigate } = useRouter()
  const [reload, setReload] = useState(false)

  // const onDelete = async (id: number) => {
  //   await api.delete(`/atividade/${id}`).finally(() => setReload(!reload))
  // }

  return (
    <ContainerTabela>
      <HeaderPage
        title='Usuário por Empresa'
        extra={[
          <Button
            key='insert'
            icon={<PlusOutlined />}
            size='large'
            type='primary'
            onClick={() =>
              navigate('/manutencao/seguranca/usuario_empresa/novo')
            }
          >
            Novo
          </Button>,
        ]}
      />
      <List
        style={{ backgroundColor: '#FFF' }}
        itemLayout='horizontal'
        bordered
        // loading
        renderItem={(item) => (
          <List.Item
            actions={[
              <Button
                key='edit'
                onClick={() =>
                  navigate(`/manutencao/seguranca/usuario_empresa}`, {
                    state: item,
                  })
                }
                type='link'
                icon={<EditOutlined />}
              >
                Editar
              </Button>,
              <Popconfirm
                key='delete'
                title='Deseja realmente excluir este registro?'
                onConfirm={() => {}}
              >
                <Button key='delete' type='text' icon={<DeleteOutlined />}>
                  Apagar
                </Button>
              </Popconfirm>,
            ]}
          >
            <List.Item.Meta title='Empresa' />
            <List.Item.Meta title='Usuário' />
            <List.Item.Meta title='Descrição do grupo' />
            <List.Item.Meta title='Situação' />
          </List.Item>
        )}
      />
    </ContainerTabela>
  )
}
